import { render, staticRenderFns } from "./QuizArea.vue?vue&type=template&id=7816c514&scoped=true&"
import script from "./QuizArea.vue?vue&type=script&lang=ts&"
export * from "./QuizArea.vue?vue&type=script&lang=ts&"
import style0 from "./QuizArea.vue?vue&type=style&index=0&id=7816c514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816c514",
  null
  
)

export default component.exports